export const variationsFields = /* GraphQL */ `
  fragment variationsFields on Variations {
    labels {
      tag
      title_singular
      title_plural
      choose_one
      choose_another
      unavailable
    }
    options {
      slug
      name
      available
      tag
    }
  }
`
